import _ from 'lodash';
import t from 'javascripts/utils/translation';
import {action, computed, observable} from 'mobx';
import {format, parse} from 'date-fns';

export default class {
  defaultHonoree = {
    amountHidden: false,
    deliveryNotification: false,
    fromFullName: '',
    honoreeFullName: '',
    message: '',
    recipientEmail: '',
    recipientFullName: '',
    sendOn: format(new Date(), t('views.donate_form.iho.date_parse_format')),
    sendTo: 'honoree',
    sendType: 'now',
    type: 'email',
  }

  @computed get donationFormParams() {
    const params = {
      amount_hidden: this.honoree.amountHidden,
      delivery_notification: this.honoree.deliveryNotification,
      design: this.design.slug,
      from_full_name: this.honoree.fromFullName,
      gift_duration: this.giftDuration,
      honoree_full_name: this.honoree.honoreeFullName,
      message: this.honoree.message,
      recipient_email: this.honoree.recipientEmail,
      recipient_full_name: this.honoree.sendTo === 'honoree' ? this.honoree.honoreeFullName : this.honoree.recipientFullName,
      send_to: this.honoree.sendTo,
      type: this.honoree.type,
    };

    if(this.honoree.sendType === 'schedule') {
      params['send_on'] = format(parse(this.honoree.sendOn, t('views.donate_form.iho.date_parse_format'), new Date()), 'yyyy-MM-dd');
    }

    return params;
  }

  @computed get steps() {
    return {
      email: [
        'type',
        'details',
        'delivery',
        'design',
        'preview',
      ],
      print: [
        'type',
        'details',
        'delivery',
        'preview',
      ],
    }[this.honoreeDraft.type];
  }

  @computed get isFirstStep() {
    return this.step === this.steps[0];
  }

  @computed get isLastStep() {
    return this.step === this.steps[
      this.steps.length - 1
    ];
  }

  @observable chooseDesignMode = false;
  @observable design = {};
  @observable designs = [];
  @observable giftDuration = 1;
  @observable honoree = this.defaultHonoree;
  @observable honoreeDraft = this.defaultHonoree;
  @observable honoreeInfoIsPresent = false;
  @observable isSpringIho = false;
  @observable modalOpen = false;
  @observable previewLoading;
  @observable sendToHonoreeLabel = 'honoree';
  @observable step = this.steps[0];
  @observable tab = 'form';

  @action saveHonoree = () => {
    this.honoree = _.cloneDeep(this.honoreeDraft);
    this.honoreeInfoIsPresent = true;
  };

  @action removeHonoree = () => {
    this.honoree = this.defaultHonoree;
    this.honoreeDraft = this.defaultHonoree;
    this.honoreeInfoIsPresent = false;
    this.step = this.steps[0];
  };

  @action updateHonoreeDraft = (event) => {
    const {target} = event;

    const value = target.type === 'checkbox' ?
      target.checked : target.value;

    this.honoreeDraft[target.name] = value;
  };

  @action handleNextStep = () => {
    this.step = this.steps[
      this.steps.indexOf(this.step) + 1
    ];
  };

  @action handlePreviousStep = () => {
    this.step = this.steps[
      this.steps.indexOf(this.step) - 1
    ];
  };

  @action setDesigns = (designs) => {
    this.designs = designs;
    this.design = designs[0];
  };

  @action handleSendToChange = (value) => {
    this.honoreeDraft.sendTo = value;
  };
}
